import React from 'react';
import ApplicantStageIndicator from 'ats/components/applicant-stage-indicator/ApplicantStageIndicator';
import EllipsisTooltipLabel from 'ats/components/ellipsis-tooltip-label/EllipsisTooltipLabel';

export default function InternalStageCell({
	stageLabel,
	statusLabel,
	stageLevel,
	statusColor
}) {
	if (!stageLabel) {
		return null;
	}

	return (
		<div className="internal-stage-cell">
			<ApplicantStageIndicator
				stageLabel={stageLabel}
				statusLabel={statusLabel}
				stageLevel={stageLevel}
				statusColor={statusColor}
				showTooltip={false}
			/>
			<EllipsisTooltipLabel
				wrapperClassName="internal-stage-cell__label-wrap"
				className="internal-stage-cell__label"
				text={stageLabel}
			/>
		</div>
	);
}
